import React, { useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import DashLayout from '../../components/DashLayout';

const nav = [
  { to: '/super-admin', icon: '📊', label: 'Dashboard' },
  { to: '/super-admin/businesses', icon: '🏢', label: 'Businesses' },
  { to: '/super-admin/payments', icon: '💰', label: 'Payments' },
  { to: '/super-admin/invoice-report', icon: '🧾', label: 'Invoice Report' },
  { to: '/super-admin/tickets', icon: '🎫', label: 'Support Tickets' },
  { to: '/super-admin/plans', icon: '📦', label: 'Plans' },
  { to: '/super-admin/agents', icon: '👥', label: 'Agent Requests' }
];

export default function SuperAdminAgents() {
  const [requests, setRequests] = useState([]);
  const [resetModal, setResetModal] = useState(null);
  const [newPass, setNewPass] = useState('');

  const load = () => axios.get('/api/super-admin/forgot-password-requests').then(r => setRequests(r.data.data || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const resetPassword = async () => {
    if (!newPass || newPass.length < 8) return toast.error('Password must be at least 8 characters');
    try {
      await axios.put(`/api/super-admin/reset-agent-password/${resetModal.id}`, { new_password: newPass });
      toast.success(`Password reset for ${resetModal.name}`);
      setResetModal(null); setNewPass(''); load();
    } catch { toast.error('Reset failed'); }
  };

  return (
    <DashLayout navItems={nav} role="Super Admin">
      <div style={{ padding: 28 }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 4 }}>Agent Password Requests</h1>
        <p style={{ color: '#555', fontSize: 13, marginBottom: 28 }}>Agents who forgot their password — reset manually here</p>

        {resetModal && (
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.9)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100 }}>
            <div style={{ background: '#111', border: '1px solid #1e1e1e', borderRadius: 16, padding: 28, width: '100%', maxWidth: 420 }}>
              <h3 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>Reset Password</h3>
              <p style={{ color: '#555', fontSize: 13, marginBottom: 20 }}>
                Agent: <strong style={{ color: '#fff' }}>{resetModal.name}</strong> ({resetModal.email})<br />
                Business: <strong style={{ color: '#fff' }}>{resetModal.company_name}</strong>
              </p>
              <input type="password" value={newPass} onChange={e => setNewPass(e.target.value)} placeholder="New password (min 8 characters)" style={{ marginBottom: 16 }} />
              <div style={{ display: 'flex', gap: 10 }}>
                <button onClick={() => { setResetModal(null); setNewPass(''); }} style={{ flex: 1, padding: '10px', background: '#1a1a1a', border: '1px solid #1e1e1e', color: '#fff', borderRadius: 8, cursor: 'pointer', fontSize: 14 }}>Cancel</button>
                <button onClick={resetPassword} style={{ flex: 2, padding: '10px', background: '#00d55b', color: '#000', borderRadius: 8, fontWeight: 700, cursor: 'pointer', fontSize: 14 }}>Reset Password</button>
              </div>
            </div>
          </div>
        )}

        {requests.length === 0 ? (
          <div style={{ background: '#111', border: '1px solid #1e1e1e', borderRadius: 12, padding: 48, textAlign: 'center' }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>✓</div>
            <div style={{ color: '#00d55b', fontSize: 16, fontWeight: 600 }}>No pending requests</div>
            <div style={{ color: '#555', fontSize: 13, marginTop: 6 }}>No agents have requested password resets</div>
          </div>
        ) : (
          <div style={{ background: '#111', border: '1px solid #1e1e1e', borderRadius: 12, overflow: 'hidden' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ borderBottom: '1px solid #1e1e1e' }}>
                  {['Agent', 'Business', 'Requested', 'Action'].map(h => (
                    <th key={h} style={{ padding: '11px 16px', textAlign: 'left', fontSize: 11, color: '#555', fontWeight: 500, textTransform: 'uppercase' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {requests.map(r => (
                  <tr key={r.id} style={{ borderBottom: '1px solid #0d0d0d' }}>
                    <td style={{ padding: '12px 16px' }}>
                      <div style={{ fontSize: 13, fontWeight: 500 }}>{r.name}</div>
                      <div style={{ fontSize: 11, color: '#555' }}>{r.email}</div>
                    </td>
                    <td style={{ padding: '12px 16px', fontSize: 13, color: '#888' }}>{r.company_name}</td>
                    <td style={{ padding: '12px 16px', fontSize: 12, color: '#555' }}>{r.forgot_password_at ? new Date(r.forgot_password_at).toLocaleString() : '—'}</td>
                    <td style={{ padding: '12px 16px' }}>
                      <button onClick={() => setResetModal(r)} style={{ padding: '6px 16px', background: 'rgba(0,213,91,0.1)', border: '1px solid #00d55b', color: '#00d55b', borderRadius: 6, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>Reset Password</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </DashLayout>
  );
}